import { render, staticRenderFns } from "./mGameCatNav.vue?vue&type=template&id=e4d629b2&scoped=true"
import script from "./mGameCatNav.vue?vue&type=script&lang=js"
export * from "./mGameCatNav.vue?vue&type=script&lang=js"
import style0 from "./mGameCatNav.vue?vue&type=style&index=0&id=e4d629b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d629b2",
  null
  
)

export default component.exports